var map = {
	"./ADA.svg": 902,
	"./BCH.svg": 903,
	"./BNB.svg": 904,
	"./BTC.svg": 905,
	"./CHZ.svg": 906,
	"./DASH.svg": 907,
	"./DOGE.svg": 908,
	"./DOT.svg": 909,
	"./ETC.svg": 910,
	"./ETH.svg": 911,
	"./EUR.svg": 912,
	"./GBP.svg": 913,
	"./LINK.svg": 914,
	"./LTC.svg": 915,
	"./MATIC.svg": 916,
	"./MKR.svg": 917,
	"./SHIB.svg": 918,
	"./SOL.svg": 919,
	"./TRX.svg": 920,
	"./UNI.svg": 921,
	"./USD.svg": 922,
	"./USDT.svg": 923,
	"./XLM.svg": 924,
	"./XMR.svg": 925,
	"./XRP.svg": 926,
	"./documents.svg": 927
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 901;